<template>
  <div v-if="currentRoles.name === '标签管理'" class="page-index label-manage-edit">
    <div style="padding: 30px;">
      <div class="toolbar-box">
        <detail-back page="label-manage"></detail-back>
        <div style="flex:1"></div>
        <el-button v-if="currentRoles.roles['标签管理-新增']" class="btn-left" size="mini" @click="submitLabel">保存</el-button>
      </div>

      <div class="edit-box">
        <el-form ref="labelForm" :model="detail">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="公司logo">
                <div class="el-input">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <upload-image-cropper ref="logo" :fixedNumber="[1, 1]" width="70" height="70"></upload-image-cropper>
                    </el-col>
                    <el-col :span="12">
                      <img v-if="detail.logoUrlPath" :src="detail.logoUrlPath" width="70" height="70" />
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="标签名称">
                <el-input placeholder="请输入标签名称" v-model="detail.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板">
                <el-select class="search-input" v-model="detail.labelModuleId" placeholder="请选择模板">
                  <el-option v-for="item in labelModuleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司">
                <el-select class="search-input" v-model="detail.companyId" @change="getLicense" placeholder="请选择公司">
                  <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="许可证">
                <el-select class="search-input" v-model="detail.companyLicense" placeholder="请选择许可证">
                  <el-option v-for="item in licenseList" :key="item.id" :label="item.licenseNumber" :value="item.licenseNumber"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="是否委托" label-width="80px" class="switch-label">
                <el-switch
                  v-model="isEntrust"
                  active-color="#13ce66"
                  inactive-color="#606266">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="isEntrust">
            <el-col :span="12">
              <el-form-item label="委托公司">
                <el-select class="search-input" v-model="detail.entrustCompanyId" @change="getEntrustLicense" placeholder="请选择委托公司">
                  <el-option v-for="item in entrustList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="委托公司许可证">
                <el-select class="search-input" v-model="detail.entrustCompanyLicense" placeholder="请选择委托公司许可证">
                  <el-option v-for="item in entrustLicenseList" :key="item.id" :label="item.licenseNumber" :value="item.licenseNumber"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品">
                <el-select
                    class="search-input"
                    filterable
                    remote
                    :remote-method="getProductList"
                    v-model="detail.product.id"
                    @change="changeProduct"
                    placeholder="请选择商品">
                  <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="复用的商品模板">
                <el-select
                    class="search-input"
                    filterable
                    remote
                    :remote-method="getCopyProductList"
                    v-model="copyProductId"
                    @change="copyProductDetail"
                    placeholder="请选择复用的商品模板">
                  <el-option v-for="item in copyProductList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品通用名">
                <el-select class="search-input" v-model="detail.product.sortName" placeholder="请选择商品通用名">
                  <el-option v-for="item in sortNameList" :key="item.value" :label="item.description" :value="item.description"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="饲喂阶段">
                <el-select class="search-input" v-model="detail.product.feedStage" placeholder="请选择饲喂阶段">
                  <el-option v-for="item in feedStageList" :key="item.value" :label="item.description" :value="item.description"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="产品标准编号">
                <el-input placeholder="请输入产品标准编号" v-model="detail.product.standardNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="产品成分分析保证值（%）">
                <div class="el-input">
                  <table class="table-box">
                    <tr v-for="(item, i) in componentList" :key="item">
                      <template v-for="(component, j) in item">
                        <!-- eslint-disable -->
                        <td>{{component.description}}</td>
                        <td v-if="detail.product.productIngredients[(i * 3) + j]" @click="toast((i * 3) + j)">{{detail.product.productIngredients[(i * 3) + j].value}}</td>
                        <td v-else>-</td>
                      </template>
                    </tr>
                  </table>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="原料组成">
                <el-input placeholder="请输入原料组成" v-model="detail.product.material"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="净含量">
                <el-input placeholder="请输入净含量" v-model="detail.product.netWeight"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保质期">
                <el-input placeholder="请输入保质期" v-model="detail.product.period"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        class="dialog"
        width="400px">
      <el-row :gutter="20">
        <el-col :span="symbol === '-' ? 12 : 16">
          <el-select class="search-input" v-model="symbol">
            <el-option label="大于等于" value="≥"></el-option>
            <el-option label="小于等于" value="≤"></el-option>
            <el-option label="大于" value=">"></el-option>
            <el-option label="小于" value="<"></el-option>
            <el-option label="两者之间" value="-"></el-option>
          </el-select>
        </el-col>
        <el-col :span="symbol === '-' ? 6 : 8">
          <el-input placeholder="成分值" v-model="currentComponentValue"></el-input>
        </el-col>
        <el-col :span="6" v-if="symbol === '-'">
          <el-input placeholder="成分值" v-model="currentComponentValue2"></el-input>
        </el-col>
      </el-row>
      <div style="display:flex;margin-top:10px">
        <div style="flex:1"></div>
        <el-button class="btn-left" @click="componentChange">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import DetailBack from '../../components/detail-back/detail-back'
  import { formatDate, dynamicChangeRoute } from '../../utils/common'
  import { apiDetail, apiLabelModuleList, apiLabelEdit as apiEdit } from '../../api/label'
  import { apiList as apiProductList, apiDetail as apiProductDetail } from '../../api/product'
  import { apiFeedStage, apiSortName, apiType } from '../../api/master'
  import { apiLicense } from '../../api/organization'
  import { apiList as apiEntrustList } from '../../api/entrust'
  import { Message } from 'element-ui'
  import { apiUpload } from '../../api/file'
  import UploadImageCropper from '../../components/upload-image-cropper/upload-image-cropper'

  export default {
    mixins: [tableMixin],
    name: 'label-manage-edit',
    data() {
      return {
        id: 0,
        detail: {}, // 标签详情
        licenseList: [], // 分公司许可证
        isEntrust: false, // 是否委托
        entrustList: [], // 委托公司列表
        entrustLicenseList: [], // 委托公司许可证
        productList: [], // 商品列表
        copyProductList: [], // 复用商品列表
        copyProductId: '', // 复用的商品Id
        labelModuleList: [], // 标签模板列表
        feedStageList: [], // 饲喂阶段列表
        sortNameList: [], // 通用名列表
        componentList: [], // 成分列表（二维数组）
        productIngredients: [], // 成分列表
        currentComponent: {}, // 当前成分
        dialogVisible: false, // 成分弹窗
        symbol: '≥', // 符号
        currentComponentValue: '', // 当前成分值
        currentComponentValue2: '' // 当前成分值2
      }
    },
    components: {
      DetailBack,
      UploadImageCropper
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      this.detail = {
        id: 0,
        name: '',
        labelModuleId: '',
        companyId: '',
        companyLicense: '',
        entrustCompanyId: '',
        entrustCompanyLicense: '',
        logoUrl: '',
        logoUrlPath: '',
        product: {
          id: '',
          name: '',
          sortName: '',
          feedStage: '',
          standardNumber: '',
          productIngredients: [{
            value: ''
          }],
          material: '',
          netWeight: '',
          period: ''
        }
      }
    },
    activated() {
      this.clearAllData()
      this.id = this.$route.params.id
      if (this.id === 0) {
        this.detail.companyId = this.userInfo.companyList[0].id
      }
      this.getLabelDetail()
      this.getLabelModule()
      this.getEntrustList()
      this.getEntrustLicense()
      this.getFeedStage()
      this.getSortName()
      // this.getComponent()
    },
    methods: {
      // 提交
      submitLabel() {
        let params = Object.assign({}, this.detail)
        if (params.id === 0) {
          params.id = null
        }
        if (!this.isEntrust) {
          params.entrustCompanyId = null
          params.entrustCompanyLicense = null
        }
        let param = null
        if (this.$refs.logo.file.raw !== undefined) {
          param = new FormData()
          param.append('file', this.$refs.logo.file.raw, this.$refs.logo.file.name)
        }
        apiUpload(param).then(imageUrl => {
          params.logoUrl = imageUrl.data
          if (params.logoUrl === '') {
            delete params.logoUrl
          }
          apiEdit(params, params.companyId).then(() => {
            if (params.id === 0) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
            } else {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
            }
            this.$refs.logo.file = {}
          })
        })
      },
      // 获取标签详情
      getLabelDetail() {
        if (this.id === 0) return
        apiDetail(this.id).then(data => {
          this.copyObject(this.detail, data.data)
          this.detail.product.productIngredients = data.data.product.productIngredients
          if (!(this.detail.labelModuleId > 0)) {
            this.detail.labelModuleId = ''
          }
          if (this.detail.product.id > 0) {
            this.getProductList(this.detail.product.name)
          }
          if (this.detail.companyId > 0) {
            this.getLicense()
          }
          if (this.detail.entrustCompanyId > 0) {
            this.isEntrust = true
          }
          this.getComponent()
          this.getCopyProductList('')
        })
      },
      // 获取标签模板
      getLabelModule() {
        let pageIndex = 1
        let pageSize = 999
        apiLabelModuleList(pageIndex, pageSize).then(data => {
          this.labelModuleList = data.data.data
        })
      },
      // 获取分公司许可证列表
      getLicense() {
        if (this.detail.companyId === '') return
        apiLicense(this.detail.companyId, 1).then(data => {
          this.licenseList = data.data
        })
        if (this.isEntrust) {
          this.getEntrustList()
        }
      },
      // 获取委托公司许可证列表
      getEntrustLicense() {
        if (this.detail.entrustCompanyId === '') return
        apiLicense(this.detail.entrustCompanyId, 2).then(data => {
          this.entrustLicenseList = data.data
        })
      },
      // 获取委托公司列表
      getEntrustList() {
        let searchCondition = {
          companyIds: this.detail.companyId
        }
        apiEntrustList(searchCondition, 1, 999).then(data => {
          this.entrustList = data.data.data
        })
      },
      // 获取商品列表
      getProductList(value) {
        if (this.detail.companyId === '') return
        apiProductList(this.detail.companyId, value, 0, '', 1, 10).then(data => {
          this.productList = data.data.data
        })
      },
      // 获取复用商品列表
      getCopyProductList(value) {
        if (this.detail.companyId === '') return
        apiProductList(this.detail.companyId, value, 0, '', 1, 10).then(data => {
          this.copyProductList = data.data.data
        })
      },
      changeProduct() {
        apiProductDetail(this.detail.product.id).then(data => {
          let product = {
            id: '',
            name: '',
            sortName: '',
            feedStage: '',
            standardNumber: '',
            productIngredients: [],
            material: '',
            netWeight: '',
            period: ''
          }
          this.copyObject(product, data.data)
          this.productIngredients.forEach((item, index) => {
            if (product.productIngredients.length < this.productIngredients.length) {
              product.productIngredients[index] = {
                type: item.value,
                value: data.data.productIngredients[index] ? data.data.productIngredients[index].value : ''
              }
            } else {
              if (product.productIngredients[index].value === undefined) {
                product.productIngredients[index].value = ''
              }
            }
          })
          this.detail.product = product
        })
      },
      // 复用商品信息
      copyProductDetail() {
        if (this.copyProductId === '' || this.copyProductId === 0) return
        apiProductDetail(this.copyProductId).then(data => {
          let product = this.detail.product
          // let copyProduct = Object.assign({}, data.data, product)
          this.copyObject(product, data.data, false)
          this.detail.product = product
        })
      },
      // 获取商品饲喂阶段选择列表
      getFeedStage() {
        apiFeedStage().then(data => {
          this.feedStageList = data.data
        })
      },
      // 获取商品通用名选择列表
      getSortName() {
        apiSortName().then(data => {
          this.sortNameList = data.data
        })
      },
      // 获取商品配料类型选择列表
      getComponent() {
        let productIngredients = JSON.parse(JSON.stringify(this.detail.product.productIngredients))
        apiType().then(data => {
          let a = []
          let b = []
          this.productIngredients = data.data
          data.data.forEach((item, index) => {
            if (productIngredients.length < data.data.length) {
              productIngredients[index] = {
                type: item.value,
                value: ''
              }
            } else {
              if (productIngredients[index].value === undefined) {
                productIngredients[index].value = ''
              }
            }
            if (index !== 0 && index % 3 === 0) {
              a.push(b)
              b = []
              b.push(item)
            } else if (index + 1 === data.data.length && (index + 1) % 3 !== 0) {
              b.push(item)
              for (let i = 0; i < (3 - (data.data.length % 3)); i++) {
                b.push({
                  description: '-',
                  value: '-'
                })
              }
              a.push(b)
            } else if (index + 1 === data.data.length && (index + 1) % 3 === 0) {
              b.push(item)
              a.push(b)
            } else {
              b.push(item)
            }
          })
          this.detail.product.productIngredients = productIngredients
          this.componentList = a
        })
      },
      // 成分值弹框
      toast(index) {
        this.dialogVisible = true
        this.currentComponentValue = ''
        this.currentComponentValue2 = ''
        let currentComponent = this.detail.product.productIngredients[index]
        if (currentComponent.value) {
          if (currentComponent.value.indexOf('-') !== -1) {
            this.symbol = '-'
            this.currentComponentValue = currentComponent.value.split('-')[0]
            this.currentComponentValue2 = currentComponent.value.split('-')[1]
          } else if (currentComponent.value.indexOf('≥') !== -1) {
            this.symbol = '≥'
            this.currentComponentValue = currentComponent.value.split('≥')[1]
          } else if (currentComponent.value.indexOf('≤') !== -1) {
            this.symbol = '≤'
            this.currentComponentValue = currentComponent.value.split('≤')[1]
          } else if (currentComponent.value.indexOf('>') !== -1) {
            this.symbol = '>'
            this.currentComponentValue = currentComponent.value.split('>')[1]
          } else if (currentComponent.value.indexOf('<') !== -1) {
            this.symbol = '<'
            this.currentComponentValue = currentComponent.value.split('<')[1]
          }
        } else {
          this.symbol = '≥'
        }
        currentComponent.index = index
        this.currentComponent = currentComponent
      },
      // 成分值修改
      componentChange() {
        let currentComponent = this.currentComponent
        let symbol = this.symbol
        let value = this.currentComponentValue
        let value2 = this.currentComponentValue2
        let i = currentComponent.index
        if (symbol === '-') {
          if (value2 > value && value && value2) {
            this.detail.product.productIngredients[i].value = value + symbol + value2
          } else {
            Message.error('后者的值必须大于前者的值或值不能为空')
            return
          }
        } else {
          if (value) {
            this.detail.product.productIngredients[i].value = symbol + value
          } else {
            Message.error('值不能为空')
            return
          }
        }
        this.dialogVisible = false
      },
      // 对象赋值
      copyObject(obj1, obj2, flag = true) {
        for (let i in obj1) {
          for (let j in obj2) {
            if (typeof obj1[i] !== 'object') {
              if (i === j) {
                if (flag) {
                  obj1[i] = obj2[j]
                } else {
                  if (obj1[i] === '') {
                    obj1[i] = obj2[j]
                  }
                }
              }
            } else {
              if (i === j) {
                this.copyObject(obj1[i], obj2[j])
              }
            }
          }
        }
      },
      // 清除数据
      clearAllData() {
        this.id = 0
        this.detail = {
          id: 0,
          name: '',
          labelModuleId: '',
          companyId: '',
          companyLicense: '',
          entrustCompanyId: '',
          entrustCompanyLicense: '',
          logoUrl: '',
          logoUrlPath: '',
          product: {
            id: '',
            name: '',
            sortName: '',
            feedStage: '',
            standardNumber: '',
            productIngredients: [{
              value: ''
            }],
            material: '',
            netWeight: '',
            period: ''
          }
        }
        this.licenseList = []
        this.isEntrust = false
        this.entrustList = []
        this.entrustLicenseList = []
        this.productList = []
        this.copyProductList = []
        this.copyProductId = ''
        this.labelModuleList = []
        this.feedStageList = []
        this.sortNameList = []
        this.componentList = []
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.label-manage-edit
    height calc(100vh - 60px - 51px)
    padding 0
    .el-dialog__header
      padding 0
    .edit-box
      background #fff
      padding 20px
      padding-top 0
    .table-box
      border-collapse collapse
      display table
      width 100%
      td
        text-align center
        padding 5px 10px
        border 1px solid #DDD
        width calc(100% / 6)
    .switch-label
      .el-form-item__label
        text-align left
    .el-form-item__content > div
      width 100%
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
</style>
